import axios from 'axios'

export class Fahrzeugarten{
    static async get(){
        try {
            const response = await axios.get(
                `https://feuerwehr-server.org:5000/fahrzeugarten`
            );

            return response.data;
        } catch (err) {
            console.error(err);
            return false;
        }
    }
}
